var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 359.105,
    height: 311,
    viewBox: "0 0 359.105 311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    transform: "translate(-3.528 -8.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M4.528,49.5h39.3",
    transform: "translate(0 229.443)",
    fill: "none",
    stroke: "#2b4255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M25.513,51.5H157.574M38.7,64.723h34.8m18.1,0h46.678M65.077,77.947h33.1",
    transform: "translate(117.76 240.666)",
    fill: "none",
    stroke: "#f05542",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M28.516,1012.693a2.823,2.823,0,0,0-2.79,2.882c0,1.964-.84,2.857-2.79,2.857-3.835-.066-3.835,5.732,0,5.673,1.878,0,2.79.529,2.79,2.737-.053,3.835,5.726,3.835,5.673,0,0-2.01.939-2.737,2.8-2.737,3.835.066,3.835-5.726,0-5.673-2.532,0-2.8-1.442-2.8-2.856a2.843,2.843,0,0,0-2.883-2.883Z",
    transform: "translate(87.16 -900.165)",
    fill: "#f05542",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M22.677,1132.733a1.55,1.55,0,0,0-1.527,1.587c0,1.078-.463,1.567-1.534,1.567a1.554,1.554,0,1,0,0,3.107c1.031,0,1.534.291,1.534,1.507a1.554,1.554,0,1,0,3.107,0c0-1.1.529-1.5,1.547-1.5a1.557,1.557,0,1,0,0-3.114c-1.388,0-1.541-.794-1.541-1.573a1.561,1.561,0,0,0-1.587-1.58Zm14.962-132.167a2.05,2.05,0,0,0-2.036,2.1c0,1.434-.615,2.083-2.036,2.083a2.066,2.066,0,1,0,0,4.133c1.369,0,2.036.377,2.036,2a2.066,2.066,0,1,0,4.132,0c0-1.468.688-2,2.043-2a2.066,2.066,0,1,0,0-4.133c-1.845,0-2.043-1.057-2.043-2.083a2.07,2.07,0,0,0-2.1-2.1Z",
    transform: "translate(75.816 -968.21)",
    fill: "#2b4255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M44.685,999.958a1.553,1.553,0,0,0-1.534,1.587c0,1.078-.463,1.567-1.534,1.567a1.554,1.554,0,1,0,0,3.107c1.031,0,1.534.291,1.534,1.507a1.554,1.554,0,1,0,3.107,0c0-1.1.522-1.5,1.541-1.5a1.557,1.557,0,1,0,0-3.114c-1.388,0-1.534-.794-1.534-1.573a1.561,1.561,0,0,0-1.587-1.581Z",
    transform: "translate(199.257 -971.629)",
    fill: "#f05542",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M55.307,1006.142a2.05,2.05,0,0,0-2.036,2.1c0,1.429-.608,2.083-2.03,2.083a2.066,2.066,0,1,0,0,4.132c1.369,0,2.03.377,2.03,1.991a2.07,2.07,0,1,0,4.139,0c0-1.461.681-1.991,2.036-1.991a2.066,2.066,0,1,0,0-4.132c-1.838,0-2.036-1.058-2.036-2.083a2.07,2.07,0,0,0-2.1-2.1Z",
    transform: "translate(250.367 -936.926)",
    fill: "#2b4255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M56.506,1014.116a1.549,1.549,0,0,0-1.527,1.587c0,1.071-.463,1.567-1.534,1.567a1.554,1.554,0,1,0,0,3.107c1.031,0,1.534.291,1.534,1.507a1.554,1.554,0,1,0,3.107,0c0-1.1.529-1.5,1.547-1.5a1.557,1.557,0,1,0,0-3.114c-1.388,0-1.541-.794-1.541-1.573a1.56,1.56,0,0,0-1.587-1.58Zm-2.2,51.815a2.823,2.823,0,0,0-2.79,2.882c0,1.964-.84,2.857-2.79,2.857-3.835-.066-3.835,5.726,0,5.673,1.878,0,2.79.522,2.79,2.737-.053,3.834,5.726,3.834,5.673,0,0-2.016.939-2.738,2.8-2.738,3.835.067,3.835-5.725,0-5.672-2.532,0-2.8-1.448-2.8-2.857a2.843,2.843,0,0,0-2.883-2.882Z",
    transform: "translate(231.873 -892.173)",
    fill: "#f05542",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M28.5,1056.943a2.049,2.049,0,0,0-2.03,2.1c0,1.428-.615,2.083-2.036,2.083a2.066,2.066,0,1,0,0,4.132c1.369,0,2.036.377,2.036,1.99a2.066,2.066,0,1,0,4.132,0c0-1.468.681-1.99,2.043-1.99a2.066,2.066,0,1,0,0-4.132c-1.851,0-2.05-1.057-2.05-2.083a2.07,2.07,0,0,0-2.1-2.1Zm50.738-59.968a1.6,1.6,0,0,0-1.574,1.626c0,1.111-.476,1.614-1.574,1.614a1.6,1.6,0,1,0,0,3.193c1.058,0,1.574.291,1.574,1.54a1.6,1.6,0,1,0,3.193,0c0-1.137.529-1.54,1.58-1.54a1.6,1.6,0,1,0,0-3.193c-1.428,0-1.587-.82-1.587-1.613a1.6,1.6,0,0,0-1.613-1.62Z",
    transform: "translate(99.914 -988.362)",
    fill: "#2b4255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M46.053,33.139a70.784,70.784,0,0,0-22.1,51.809,72.232,72.232,0,0,0,4.985,26.3C39.117,85.212,63.256,68.207,90.06,68.194c26.83,0,50.976,17.058,61.131,43.115a72.3,72.3,0,0,0,4.985-26.361A70.752,70.752,0,0,0,133.5,32.61",
    transform: "translate(108.989 134.663)",
    fill: "none",
    stroke: "#2b4255",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M28.71,42.738a87.1,87.1,0,0,1,12.1-4.258m8.45-1.95c1.441-.264-1.448.192,0,0m9.7-.912a85.888,85.888,0,0,1,38.771,7.127",
    transform: "translate(135.701 150.942)",
    fill: "none",
    stroke: "#2b4255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M26.95,113.153A131.9,131.9,0,0,0,46.461,181.22c8.529-3.491,17.527-5.818,26.764-5.838a71.515,71.515,0,0,1,27.061,5.316,129.643,129.643,0,0,0,19.22-67.544c-.066-37.673-14.394-73.687-43.948-99.644C52.881,33.5,36.339,59.414,29.9,87.447M27.8,98.581c-.218,1.1-.417,2.208-.6,3.319",
    transform: "translate(125.824 27.475)",
    fill: "none",
    stroke: "#2b4255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M38.8,53.632a39.657,39.657,0,0,1,50.91,47.835h0c4.278-9.911,14.175-17.3,24.747-15.127,1.567,6.387,4.02,10.136,6.744,13.038A20.747,20.747,0,0,1,146.25,66.743l.066,10.989V39.748c6.744-2.539,13.739-2.136,20.873,0V89.507l.066-23.485a22.077,22.077,0,0,1,25.918,3.438,20.747,20.747,0,0,1,0,29.342c3.775-3.465,4.43-8.073,6.969-12.668,10.579-2.175,22.876,4.2,27.161,14.1h0a22.11,22.11,0,0,1,1.917-16.225m8.384-8.635a22.109,22.109,0,0,1,30.2,8.093,22.531,22.531,0,0,1-8.086,30.566H17.264c-7.927-13.475-6.988-31.094,1.071-44.113m7.055-8.3c.826-.945,1.7-1.858,2.618-2.724",
    transform: "translate(40.699 164.861)",
    fill: "none",
    stroke: "#2b4255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M78.5,45.239a24.027,24.027,0,1,1-48.053,0h0a24.093,24.093,0,0,1,24.1-24.047A23.841,23.841,0,0,1,73.5,30.5",
    transform: "translate(145.454 70.589)",
    fill: "none",
    stroke: "#2b4255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M52.616,49.5H91.281",
    transform: "translate(269.852 229.443)",
    fill: "none",
    stroke: "#2b4255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.aa44af145ae124b16a01d331f2951340.svg";
export { ForwardRef as ReactComponent };